module.exports = __webpack_public_path__ + "img/works_nikkei_telecon_4.b91267d5.png";